const inNode = typeof window === "undefined" && typeof process === "object";
const silence = (): void => {};

/* eslint-disable no-console */
export default {
  error: inNode ? silence : console.error,
  log: inNode ? silence : console.log,
  warn: inNode ? silence : console.warn,
};
